<template>
	<section class="section-app">
		<section-head
			title="Passengers"
			description="How many passengers are occupying your cabin?"
		/>

		<div class="passengers-quantity">
			<button
				class="passengers-quantity-decrement"
				@click="decrement"
			><span></span>
			</button>
				<input
					type="number"
					name="occupancy"
					readonly="readonly"
					min="1" step="1"
					:value="count"
				>
			<button
				class="passengers-quantity-increment"
				@click="increment"
			><span></span>
			</button>
		</div>

		<div class="section__foot">
			<button
				class="btn btn-gray"
				@click="handlePrevClick"
			>
				Back
			</button>

			<button
				class="btn btn-blue"
				@click="handleNextClick"
			>
				Continue
			</button>
		</div><!-- /.section__foot -->
	</section><!-- /.section -->
</template>

<script>
/**
 * Internal Dependancies
 */
import SectionHead from '../components/SectionHead.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
	/**
	 * Component Name.
	 *
	 * @type {String}
	 */
	name: 'cruise-passangers',

	components: {
		SectionHead
	},

	data(){
		return{
			count: 2
		}
	},

	computed:{
		/**
		 * Map Store's state
		 */
		...mapGetters({
			'product': 'getProduct'
		})
	},

	methods:{
		/**
		 * Map Store's Actions
		 */
		...mapActions([
			'setProductEntry',
			'resetProductEntry',
			'completeStep',
			'resetSteps',
		]),

		handlePrevClick() {
			this.$router.push({name:'cruise.overview'})
		},

		handleNextClick() {
			if (this.product.passengers !== this.count) {
				this.resetProductEntry({
					entry: ['deck','cabin'],
				})

				this.resetSteps({
					steps: ['deck','cabin'],
				})
			}

			this.setProductEntry({
				entry: 'passengers',
				fields: this.count
			})
			this.completeStep({
				step: 'passengers'
			});
			this.$router.push({name:'cruise.deck'})
		},

		increment(){
			if (this.count < 5) {
				this.count++
			}
		},

		decrement(){
			if (this.count > 1) {
				this.count--
			}
		}
	},

	mounted(){
		if (this.product.passengers !== null) {
			this.count = this.product.passengers
		}
	}
}
</script>

<style>
.passengers-quantity { max-width: 460px; margin: auto; border-left: 10px solid #89d2bf; box-shadow: 0 0 4px rgba(0, 0, 0, .5); display: flex; align-items: center; justify-content: center; padding: 20px; background: #fff;  }

.passengers-quantity input[type="number"] { width: 80px; height: 80px; border: 2px solid #d3d3d3; border-radius: 8px; margin: 0 15px; background: #fff; font-size: 40px; color: #9b9b9b; text-align: center; font-weight: 700;  }

.passengers-quantity input[type=number] { -moz-appearance: textfield; }
.passengers-quantity input[type=number]::-webkit-inner-spin-button,
.passengers-quantity input[type=number]::-webkit-outer-spin-button { appearance: none; margin: 0; }

.passengers-quantity-increment,
.passengers-quantity-decrement { appearance: none; background: transparent; border: 0; border-radius: 0; width: 20px; height: 20px; display: flex; align-items: center;  }

.passengers-quantity-increment span,
.passengers-quantity-decrement span { position: relative; display: inline-block; vertical-align: middle; width: 20px; height: 4px; background-color: #9b9b9b; transition: background .4s; }

.passengers-quantity-increment span:after { content: ''; position: absolute; top: 0; left: 0; width: 20px; height: 4px; background-color: #9b9b9b; transform: rotate(90deg); transition: background .4s; }

.passengers-quantity-increment:hover span,
.passengers-quantity-decrement:hover span,
.passengers-quantity-increment:hover span:after { background-color: #13373d; }

.passengers-quantity-increment:hover,
.passengers-quantity-decrement:hover { text-decoration: none; }
</style>


// WEBPACK FOOTER //
// src/pages/CruisePassengers.vue